






































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import FilterArrowRight from '@/assets/images/filter-arrow-right.png';
import FilterAltOff from '@/assets/images/filter-alt-off.png';
import DropdownComponent from '@/shared/dropdown/dropdown.component.vue';
import ButtonComponent from '@/shared/button/button.component.vue';
import OptionFilter from '@/views/work-item/option-filter.json';
import FilterFields from '@/domain/project/filter-fields.entity';
import WorkItemSummary from '@/domain/work-item/work-item-summary.entity';
import Textfield from '@/shared/text-field/text-field.component.vue';
import DatePicker from './work-item-filter-date-picker.component.vue';

@Component({
  components: {
    DatePicker,
    DropdownComponent,
    ButtonComponent,
    Textfield,
  },
})
export default class WorkitemsFilter extends Vue {
  @Prop() filterFields!: FilterFields;

  @Prop({ type: Array, default: () => [] }) selectedWorkItens!: WorkItemSummary[];

  private expandFilter: boolean = false;

  private filterType: string = 'ALL';

  private clearCreateStartDate: boolean = false;

  private clearCreateEndDate: boolean = false;

  private clearEstimateStartDate: boolean = false;

  private clearEstimateEndDate: boolean = false;

  private clearConcludedStartDate: boolean = false;

  private clearConcludedEndDate: boolean = false;

  private clearOriginCreatedStartDate: boolean = false;

  private clearOriginCreatedEndDate: boolean = false;

  $refs!: any;

  images: any = {
    filterArrowRight: FilterArrowRight,
    filterAltOff: FilterAltOff,
  };

  options: any[] = OptionFilter;

  get optionsTranslated() {
    return this.options.map(option => ({
      value: option.value,
      label: this.$t(option.label),
    }));
  }

  updateNumber(event: any) {
    const number: number | null = event !== '' && event !== ' ' ? Number(event) : null;
    this.$emit('updateWorkItemNumber', number);
  }

  updateTitle(event: any) {
    this.$emit('updateWorkItemTitle', event);
  }

  updateType(event: any) {
    this.$emit('updateWorkitemType', event);
  }

  updateSystem(event: any) {
    this.$emit('updateOriginSystem', event);
  }

  updateStatus(event: any) {
    this.$emit('updateStatus', event);
  }

  updateFilterType(value: any) {
    this.filterType = value ? value.value : '';
    this.$emit('updateFilterType', this.filterType);
  }

  clearFilterType() {
    this.filterType = '';
    this.$emit('updateFilterType', this.filterType);
  }

  updateList() {
    this.$emit('update');
  }

  changeCreateStartDate(event: string) {
    this.clearCreateStartDate = false;
    this.$emit('updateCreateStartDate', event);
  }

  changeCreateEndDate(event: string) {
    this.clearCreateEndDate = false;
    this.$emit('updateCreateEndDate', event);
  }

  changeEstimatedStartDate(event: string) {
    this.clearEstimateStartDate = false;
    this.$emit('updateEstimateStartDate', event);
  }

  changeEstimatedEndDate(event: string) {
    this.clearEstimateEndDate = false;
    this.$emit('updateEstimateEndDate', event);
  }

  changeConcludedStartDate(event: string) {
    this.clearConcludedStartDate = false;
    this.$emit('updateConcludedStartDate', event);
  }

  changeConcludedEndDate(event: string) {
    this.clearConcludedEndDate = false;
    this.$emit('updateConcludedEndDate', event);
  }

  changeOriginCreatedStartDate(event: string) {
    this.clearOriginCreatedStartDate = false;
    this.$emit('updateOriginCreatedStartDate', event);
  }

  changeOriginCreatedEndDate(event: string) {
    this.clearOriginCreatedEndDate = false;
    this.$emit('updateOriginCreatedEndDate', event);
  }

  clearDateField() {
    this.$emit('clearDateField');
  }

  clearFilter() {
    this.$emit('clear');
    this.setClearDatePicker();
    if (this.$refs && this.$refs.form && typeof this.$refs.form.reset === 'function') {
      this.$refs.form.reset();
    }
    this.filterType = 'ALL';
  }

  setClearDatePicker() {
    this.clearCreateStartDate = true;
    this.clearCreateEndDate = true;
    this.clearConcludedStartDate = true;
    this.clearConcludedEndDate = true;
    this.clearEstimateStartDate = true;
    this.clearEstimateEndDate = true;
    this.clearOriginCreatedStartDate = true;
    this.clearOriginCreatedEndDate = true;
  }

  handleFilter() {
    this.expandFilter = !this.expandFilter;
    if (!this.expandFilter) {
      this.clearDateField();
    }
  }

  showModalExport(): void {
    this.$emit('showModalExport');
  }

  showModalReprocess(): void {
    this.$emit('showModalReprocess');
  }
}
